import React from 'react';

import { TravelProductToggle } from './TravelProductToggle';
import type { TravelProductId } from './TravelProductToggle.types';
import { useTravelProductNavigation } from './useTravelProductNavigation';

export type TravelProductToggleControlProps = Readonly<{
  eventHandle: string;
  activeProduct: TravelProductId;
  /** Hotel routes only — the promo advertises cars, so the car route never shows it. */
  showCarsPromoTooltip?: boolean;
}>;

// Wires up same-tab product navigation to the TravelProductToggle UI component.
const TravelProductToggleControlInner: React.FC<TravelProductToggleControlProps> = ({ eventHandle, activeProduct, showCarsPromoTooltip }) => {
  const { navigateToProduct } = useTravelProductNavigation({ eventHandle, activeProduct });

  return (
    <TravelProductToggle
      activeProduct={activeProduct}
      onProductChange={navigateToProduct}
      showCarsPromoTooltip={showCarsPromoTooltip}
    />
  );
};

export const TravelProductToggleControl = React.memo(TravelProductToggleControlInner);
